import type { ResizeHandleProps } from './components/ResizeHandle';
import type { RefAttributes } from 'react';
import type * as lazyIndex from './lazyIndex';
import { LazyModule, createLazyComponent, LazyAction, type LazyComponent } from 'owa-bundling';
import type ResizeHandleScenario from './types/ResizeHandleScenario';

const lazyModule = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "ResizeHandle" */ './lazyIndex'),
    { name: 'ResizeHandle' }
);

export const ResizeHandle: LazyComponent<
    Omit<ResizeHandleProps & RefAttributes<HTMLDivElement>, 'ref'> & RefAttributes<HTMLDivElement>,
    HTMLDivElement,
    void
> = createLazyComponent(lazyModule, m => m.ResizeHandle);
export { ResizeHandleDirection } from './components/ResizeHandleDirection';
export { default as ResizeHandleScenario } from './types/ResizeHandleScenario';
export const lazyUpdateScenarioInResizeMode: LazyAction<
    (scenario: ResizeHandleScenario | null) => void,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.updateScenarioInResizeMode);
